import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { NavbarApp } from "../components/sharedComponents/NavbarApp";
import { UserFooter } from "../components/sharedComponents/UserFooter";
import { useTheme } from "../context/ThemeContext";
import { themeLoader } from "../components/loaders/themeLoader";

export const LayoutClient = ({ children }) => {
  const { messages } = useIntl();
  const { applyTheme } = useTheme();

  // useEffect(() => {
  //   const storedSlug = localStorage.getItem("theme_slug");
  //   if (storedSlug) {
  //     themeLoader({ themeParam: storedSlug }).then((res) => {
  //       if (res?.data) {
  //         applyTheme(res.data);
  //       }
  //     });
  //   }
  // }, [applyTheme]);

  const currentYear = new Date().getFullYear();

  return (
    <>
      <NavbarApp />
      <div className="padding-wrapper">
        <div className="page-content">{children}</div>
        <UserFooter />
      </div>
      <footer className="footer">
        <div>
          &copy; {currentYear} {messages["footer_copy_right"]}
        </div>
      </footer>
    </>
  );
};
